// PageHeader override for RBC
// The main header (HeaderComponent + PointsBanner) is now rendered
// at the app level in Layout.tsx to prevent re-mounting on every page.
// This override returns null to prevent duplicate header rendering.
// If core header/footer rendering changes in the future, review Layout.tsx
// to ensure the header rendering approach remains compatible.
export const PageHeader = () => {
  return null;
};
